import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/OutstandingPurchaseOrderReport/PurchasingReportOutstandingPurchaseOrderAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PurchasingReportOutstandingPurchaseOrderActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/OutstandingPurchaseOrderReport/PurchasingOutstandingPurchaseOrder")
	}

	render() {
		return (
			<Activity 
				name="PurchasingReportOutstandingPurchaseOrder"
				RenderedComponent={this.RenderedComponent}
				context="PurchasingReportOutstandingPurchaseOrder"
				action="PurchasingReportOutstandingPurchaseOrder"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PurchasingReportOutstandingPurchaseOrderActivity)
